import { useCurrentWorkspaceFeatures } from "@dashboard/workspaces/api/helpers";

/**
 * Whether the current workspace has at least one enrolled device, read from the licenses it has used up.
 * `undefined` while the workspace features are still loading or cannot be loaded.
 */
export function useHasEnrolledDevice(): boolean | undefined {
    const { data: features } = useCurrentWorkspaceFeatures();
    if (features === undefined) {
        return undefined;
    }
    const licensesUsed = features.find((feature) => feature.feature === "LicenseLimit")?.used;
    return (licensesUsed ?? 0) > 0;
}
